/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { MySvgControllerService } from './services/my-svg-controller.service';
import { ReleaseNotesControllerService } from './services/release-notes-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    MySvgControllerService,
    ReleaseNotesControllerService,
    ApiConfiguration
  ],
})
export class ReleaseNotesModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ReleaseNotesModule> {
    return {
      ngModule: ReleaseNotesModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ReleaseNotesModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ReleaseNotesModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
